var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { actionClass } from "@ane/legacy/lib/decorators/ReduxDecorators";
import MasterDataConstants from "@ane/exp-data/lib/constants/FeatureDataConstants";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let SystemHealthBannerActions = class {
  fetchSystemHealthMessage(workspaceId, managementGroup) {
    return __async(this, null, function* () {
      var _a, _b;
      let egResult = yield MdsDataplaneResources.getExperimentationGroupV2(workspaceId, managementGroup);
      let eg = null;
      if (egResult.isSuccessful()) {
        eg = (_a = egResult.getSuccessData()) == null ? void 0 : _a.ID;
      } else {
        egResult = yield MdsDataplaneResources.getExperimentationGroupV2(workspaceId);
        if (egResult.isSuccessful()) {
          eg = (_b = egResult.getSuccessData()) == null ? void 0 : _b.ID;
        }
      }
      let healthMessage = {};
      if (!!eg) {
        healthMessage = yield MdsDataplaneResources.getConfigWithType({
          workspaceId,
          experimentationGroup: eg,
          section: MasterDataConstants.systemHealthMessage
        });
      }
      return {
        workspaceId,
        managementGroup,
        healthMessage
      };
    });
  }
};
SystemHealthBannerActions = __decorateClass([
  actionClass()
], SystemHealthBannerActions);
const systemHealthBannerActions = new SystemHealthBannerActions();
export {
  SystemHealthBannerActions,
  systemHealthBannerActions as default
};
//# sourceMappingURL=SystemHealthBannerActions.js.map
